import React from 'react';

export function ProgressBar({ memberCount }) {
  const progressPercentage = (memberCount / 5) * 100;

  return (
    <div className="mb-6">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-sm font-medium text-gray-300">
          {memberCount} / 5 joined
        </span>
        <span className="text-sm text-gray-400">
          {5 - memberCount} spots remaining
        </span>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-gray-800">
        <div
          className="h-full bg-[#4ADE80] transition-all duration-300"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  );
}
